'use client'

import { usePathname } from 'next/navigation'
import React from 'react'

const Canonical = ({ baseUrl }: { baseUrl: string }) => {
  const pathname = usePathname()

  return (
    <>
      <link rel="canonical" href={baseUrl.replace(new RegExp('/$'), '') + pathname} />
    </>
  )
}

export default Canonical
